import Vue from '@/index.js'

import page from '@/mixins/page'

import sectionBlog from '@/components/sections/section-blog'
import sectionBlogList from '@/components/sections/section-blog-list'

export default new Vue({
  el: '#app',
  components: {
    sectionBlog,
    sectionBlogList
  },
  mixins: [page]
})
